import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgSearchOutline24 = function SvgSearchOutline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.966 9.656c0-4.792 3.898-8.69 8.69-8.69 4.793 0 8.691 3.898 8.691 8.69 0 4.793-3.898 8.691-8.69 8.691-4.793 0-8.691-3.898-8.691-8.69zM24 23.316l-7.194-7.193a9.603 9.603 0 0 0 2.507-6.467C19.313 4.332 14.98 0 9.656 0S0 4.332 0 9.656c0 5.325 4.332 9.657 9.656 9.657a9.601 9.601 0 0 0 6.467-2.507L23.316 24l.684-.684z",
    fill: "currentColor"
  })));
};

var SearchOutline24Svg = SvgSearchOutline24;

export { SearchOutline24Svg as default };
//# sourceMappingURL=SearchOutline24.svg.js.map
